export enum USER_CONFIG_MODULE_TYPE {
  STAND_WORK_SHEET = 'stand-worksheet',
  INVENTORY_COUNT = 'inventory-count',
  DASHBOARD = 'dashboard',
}

export enum USER_CONFIG_MODULE_NAME {
  STAND_WORK_SHEET_ENTRY_FORM = 'stand-worksheet',
  STAND_WORK_SHEET_INFORMATION = 'stand-worksheet-information',
  STAND_WORK_SHEET_ENTRY_FORM_VIEW_CONFIG = 'stand-worksheet-view-config',
  INVENTORY_COUNT_VIEW_CONFIG = 'inventory-count-view-config',
  DASHBOARD_MODULES = 'dashboard-modules',
  DASHBOARD_WIDGETS = 'dashboard-widgets',
}
